/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getCostSetting = /* GraphQL */ `
  query GetCostSetting($user_id: Int!) {
    getCostSetting(user_id: $user_id) {
      id
      user_id
      name
      cutting_cost
      burr_cost
      burr_sanding_cost
      edge_chamfering_cost
      r6mm_chamfering_cost
      r9mm_chamfering_cost
      is_burr_enabled
      is_burr_sanding_enabled
      is_edge_chamfering_enabled
      is_r6mm_chamfering_enabled
      is_r9mm_chamfering_enabled
      created_at
      updated_at
    }
  }
`;
export const getFactorySetting = /* GraphQL */ `
  query GetFactorySetting($user_id: Int!) {
    getFactorySetting(user_id: $user_id) {
      id
      user_id
      sf_cutting_place_id
      invoice_registration_number
      created_at
      updated_at
    }
  }
`;
export const getFactoryProfile = /* GraphQL */ `
  query GetFactoryProfile($user_id: Int!) {
    getFactoryProfile(user_id: $user_id) {
      id
      user_id
      name
      postal_code
      address
      location
      website
      profile_icon
      description
      pictures
      created_at
      updated_at
    }
  }
`;
export const getCurrentUserId = /* GraphQL */ `
  query GetCurrentUserId {
    getCurrentUserId
  }
`;
export const getCurrentUser = /* GraphQL */ `
  query GetCurrentUser {
    getCurrentUser {
      id
      sub
      is_deleted
      email
      display_name
      created_at
      updated_at
    }
  }
`;
export const getProject = /* GraphQL */ `
  query GetProject($id: Int!) {
    getProject(id: $id) {
      id
      is_deleted
      user_id
      sf_opportunity_id
      name
      quantity
      material_assortment_id
      items
      cost
      pathjson_url
      toolpath_url
      thumbnail_url
      nestingjson_url
      created_at
      updated_at
      material_assortment {
        id
        is_deleted
        is_available
        user_id
        material_id
        thickness
        height
        width
        unit_price
        xy_speed
        z_speed
        path_height
        rotation_speed
        created_at
        updated_at
        material {
          id
          name
          code
          texture_albedo
          texture_normal
          created_at
          updated_at
        }
      }
    }
  }
`;
export const getProjectFactory = /* GraphQL */ `
  query GetProjectFactory($id: Int!) {
    getProjectFactory(id: $id) {
      id
      is_deleted
      user_id
      sf_opportunity_id
      name
      quantity
      material_assortment_id
      items
      cost
      pathjson_url
      toolpath_url
      thumbnail_url
      nestingjson_url
      created_at
      updated_at
      material_assortment {
        id
        is_deleted
        is_available
        user_id
        material_id
        thickness
        height
        width
        unit_price
        xy_speed
        z_speed
        path_height
        rotation_speed
        created_at
        updated_at
        material {
          id
          name
          code
          texture_albedo
          texture_normal
          created_at
          updated_at
        }
      }
    }
  }
`;
export const getProjectId = /* GraphQL */ `
  query GetProjectId($toolpath_url: String!) {
    getProjectId(toolpath_url: $toolpath_url) {
      id
      pathjson_url
      material {
        id
        name
        code
        texture_albedo
        texture_normal
        created_at
        updated_at
      }
    }
  }
`;
export const getMaterialAssortment = /* GraphQL */ `
  query GetMaterialAssortment($input: GetMaterialAssortmentInput!) {
    getMaterialAssortment(input: $input) {
      id
      is_deleted
      is_available
      user_id
      material_id
      thickness
      height
      width
      unit_price
      xy_speed
      z_speed
      path_height
      rotation_speed
      created_at
      updated_at
      material {
        id
        name
        code
        texture_albedo
        texture_normal
        created_at
        updated_at
      }
    }
  }
`;
export const getInformation = /* GraphQL */ `
  query GetInformation($id: Int!) {
    getInformation(id: $id) {
      id
      title
      content
      url
      published_at
      expired_at
      created_at
      updated_at
    }
  }
`;
export const getVersion = /* GraphQL */ `
  query GetVersion {
    getVersion {
      id
      key
      value
      created_at
      updated_at
    }
  }
`;
export const getSFOpportunity = /* GraphQL */ `
  query GetSFOpportunity($opportunity_id: String!) {
    getSFOpportunity(opportunity_id: $opportunity_id) {
      id
      stage
      name
      userName
      userEmail
      userPhone
      personalName
      corporateName
      platform
      desiredDate
      cuttingPlace
      shippingAddressType
      postalCode
      address
      addressName
      phone
      material
      materialSize
      materialThickness
      numSheets
      millSize
      estimatedTime
      finishing
      paint
      bezel
      viewerURL
      cutDataURL
      userNotes
      coupon
      connectUserName
      imageURL1
      imageURL2
      imageURL3
      imageURL4
      imageURL5
      estimatedAmount
      materialCost
      cuttingCost
      finishingCost
      paintCost
      systemFee
      discount
    }
  }
`;
export const getEstimatedCost = /* GraphQL */ `
  query GetEstimatedCost($input: GetEstimatedCostInput) {
    getEstimatedCost(input: $input) {
      cutting
      material
      finishing {
        burr
        sanding
        total
      }
      paint
      tax
      total
      total_with_tax
    }
  }
`;
export const listCostSettings = /* GraphQL */ `
  query ListCostSettings {
    listCostSettings {
      id
      user_id
      name
      cutting_cost
      burr_cost
      burr_sanding_cost
      edge_chamfering_cost
      r6mm_chamfering_cost
      r9mm_chamfering_cost
      is_burr_enabled
      is_burr_sanding_enabled
      is_edge_chamfering_enabled
      is_r6mm_chamfering_enabled
      is_r9mm_chamfering_enabled
      created_at
      updated_at
    }
  }
`;
export const listFactorySettings = /* GraphQL */ `
  query ListFactorySettings {
    listFactorySettings {
      id
      user_id
      sf_cutting_place_id
      invoice_registration_number
      created_at
      updated_at
    }
  }
`;
export const listFactoryProfiles = /* GraphQL */ `
  query ListFactoryProfiles {
    listFactoryProfiles {
      id
      user_id
      name
      postal_code
      address
      location
      website
      profile_icon
      description
      pictures
      created_at
      updated_at
    }
  }
`;
export const listFactories = /* GraphQL */ `
  query ListFactories($input: ListFactoriesInput) {
    listFactories(input: $input) {
      sf_cutting_place_id
      profile_name
      cutting_cost
      burr_cost
      burr_sanding_cost
      is_burr_enabled
      is_burr_sanding_enabled
      material_cost
      is_assortment_available
    }
  }
`;
export const listFactoriesWithCostsAndMaterials = /* GraphQL */ `
  query ListFactoriesWithCostsAndMaterials {
    listFactoriesWithCostsAndMaterials {
      profile_name
      profile_icon
      postal_code
      address
      location
      website
      description
      pictures
      cost_setting {
        id
        user_id
        name
        cutting_cost
        burr_cost
        burr_sanding_cost
        edge_chamfering_cost
        r6mm_chamfering_cost
        r9mm_chamfering_cost
        is_burr_enabled
        is_burr_sanding_enabled
        is_edge_chamfering_enabled
        is_r6mm_chamfering_enabled
        is_r9mm_chamfering_enabled
        created_at
        updated_at
      }
      materials {
        id
        name
        width
        height
        thumbnail
        assortments {
          id
          material_id
          is_available
          thickness
          unit_price
          created_at
          updated_at
        }
      }
    }
  }
`;
export const listProjects = /* GraphQL */ `
  query ListProjects {
    listProjects {
      id
      is_deleted
      user_id
      sf_opportunity_id
      name
      quantity
      material_assortment_id
      items
      cost
      pathjson_url
      toolpath_url
      thumbnail_url
      nestingjson_url
      created_at
      updated_at
      material_assortment {
        id
        is_deleted
        is_available
        user_id
        material_id
        thickness
        height
        width
        unit_price
        xy_speed
        z_speed
        path_height
        rotation_speed
        created_at
        updated_at
        material {
          id
          name
          code
          texture_albedo
          texture_normal
          created_at
          updated_at
        }
      }
    }
  }
`;
export const listMaterials = /* GraphQL */ `
  query ListMaterials {
    listMaterials {
      id
      name
      code
      texture_albedo
      texture_normal
      created_at
      updated_at
    }
  }
`;
export const listMaterialAssortments = /* GraphQL */ `
  query ListMaterialAssortments($input: ListMaterialAssortmentsInput) {
    listMaterialAssortments(input: $input) {
      id
      is_deleted
      is_available
      user_id
      material_id
      thickness
      height
      width
      unit_price
      xy_speed
      z_speed
      path_height
      rotation_speed
      created_at
      updated_at
      material {
        id
        name
        code
        texture_albedo
        texture_normal
        created_at
        updated_at
      }
    }
  }
`;
export const listMaterialsWithAssortments = /* GraphQL */ `
  query ListMaterialsWithAssortments($user_id: Int!) {
    listMaterialsWithAssortments(user_id: $user_id) {
      id
      name
      width
      height
      thumbnail
      assortments {
        id
        material_id
        is_available
        thickness
        unit_price
        created_at
        updated_at
      }
    }
  }
`;
export const listInformations = /* GraphQL */ `
  query ListInformations {
    listInformations {
      id
      title
      content
      url
      published_at
      expired_at
      created_at
      updated_at
    }
  }
`;
export const createSsoPayload = /* GraphQL */ `
  query CreateSsoPayload($createSsoPayloadInput: CreateSsoPayloadInput!) {
    createSsoPayload(createSsoPayloadInput: $createSsoPayloadInput) {
      sso
      sig
      return_sso_url
    }
  }
`;
export const calculateShipping = /* GraphQL */ `
  query CalculateShipping($calculateShippingInput: CalculateShippingInput!) {
    calculateShipping(calculateShippingInput: $calculateShippingInput) {
      shipping
      packaging_expenses
    }
  }
`;
export const chatCompletion = /* GraphQL */ `
  query ChatCompletion($threadId: String, $messages: String, $current: String) {
    chatCompletion(
      threadId: $threadId
      messages: $messages
      current: $current
    ) {
      template
      parameters {
        name
        value
      }
      conversation
    }
  }
`;



//////////////////
// WEBPACK FOOTER
// ./src/api/graphql/queries.ts
// module id = HHpe
// module chunks = 1